import { css, CSSResult } from 'lit'
import { csColorAction, csColorBackground, csColorBorder } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csBorder, csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'


const cseCarouselPaginationDotSize = css`8px`

export const cseCarouselPaginationItem = {
  dotBackgroundColor: css`var(--cse-carousel-dot-background-color, ${csColorAction.secondary})`,
  dotBackgroundColorDisabled: css`var(--cse-carousel-dot-background-color-disabled, ${csColorBackground.disabled})`,
  dotBackgroundColorHover: css`var(--cse-carousel-dot-background-color-hover, ${csColorAction.secondaryHover})`,
  dotBorderRadius: css`var(--cse-carousel-dot-border-radius, ${csBorder.radiusFull})`,
  dotHeight: css`var(--cse-carousel-dot-height, ${cseCarouselPaginationDotSize})`,
  dotWidth: css`var(--cse-carousel-dot-width, ${cseCarouselPaginationDotSize})`,
  dotBorderWidth: css`var(--cse-carousel-dot-border-width, 0)`,
  dotBorderColor: css`var(--cse-carousel-dot-border-color, ${csColorBorder.dark})`,
  dotBorderWidthHover: css`var(--cse-carousel-dot-border-width-hover, 0)`,
  dotBorderColorHover: css`var(--cse-carousel-dot-border-color-hover, ${csColorBorder.dark})`,

  dotSelectedBackgroundColor: css`var(--cse-carousel-dot-selected-background-color, ${csColorAction.linkPrimary})`,
  dotSelectedBackgroundColorHover: css`var(--cse-carousel-dot-selected-background-color-hover, ${csColorAction.linkPrimaryHover})`,
  dotSelectedBorderRadius: css`var(--cse-carousel-dot-selected-border-radius, ${csBorder.radiusFull})`,
  dotSelectedHeight: css`var(--cse-carousel-dot-selected-height, ${cseCarouselPaginationDotSize})`,
  dotSelectedWidth: css`var(--cse-carousel-dot-selected-width, 16px)`,
  dotBorderWidthSelected: css`var(--cse-carousel-dot-border-width-selected, 0)`,
  dotBorderColorSelected: css`var(--cse-carousel-dot-border-color-selected, ${csColorBorder.dark})`,
}

export const style: CSSResult = css`
  /* Dot */
  .carousel-dot {
    background-color: ${cseCarouselPaginationItem.dotBackgroundColor};
    border-width: ${cseCarouselPaginationItem.dotBorderWidth};
    border-color: ${cseCarouselPaginationItem.dotBorderColor};
    border-radius: ${cseCarouselPaginationItem.dotBorderRadius};
    cursor: pointer;
    display: block;
    padding: 0;
    height: ${cseCarouselPaginationItem.dotHeight};
    transition-duration: ${csTransition.duration};
    transition-property: background-color, width;
    transition-timing-function: ${csTransition.timingFunction};
    width: ${cseCarouselPaginationItem.dotWidth};
  }

  .carousel-dot:hover {
    background-color: ${cseCarouselPaginationItem.dotBackgroundColorHover};
    border-width: ${cseCarouselPaginationItem.dotBorderWidthHover};
    border-color: ${cseCarouselPaginationItem.dotBorderColorHover};
  }

  .carousel-dot.selected {
    background-color: ${cseCarouselPaginationItem.dotSelectedBackgroundColor};
    border-radius: ${cseCarouselPaginationItem.dotSelectedBorderRadius};
    border-width: ${cseCarouselPaginationItem.dotBorderWidthSelected};
    border-color: ${cseCarouselPaginationItem.dotBorderColorSelected};
    height: ${cseCarouselPaginationItem.dotSelectedHeight};
    width: ${cseCarouselPaginationItem.dotSelectedWidth};
  }

  .carousel-dot.selected:hover {
    background-color: ${cseCarouselPaginationItem.dotSelectedBackgroundColorHover};
  }

  .carousel-dot.disabled {
    background-color: ${cseCarouselPaginationItem.dotBackgroundColorDisabled};
    pointer-events: none;
  }
`
